<template>
    <div class="form-type-2">
        <OptionsVisits v-model="options.visits" :defaultVal="defaultOptions.visits" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" />
        <OptionsVisitDate v-model="options.visit_date" :defaultVal="defaultOptions.visit_date" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" />
        <OptionsPageSearch v-model="options.pagesearch" :defaultVal="defaultOptions.pagesearch" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" :narrow="true" />
        <OptionsLabel v-model="options.label" :defaultVal="defaultOptions.label" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" />
        <OptionsLists v-if="!audienceId" v-model="options.lists" :defaultVal="defaultOptions.lists" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" />
        <OptionsTags v-model="options.tags" :defaultVal="defaultOptions.tags" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" />
        <OptionsTagsExclude v-model="options.NOT_tags" :defaultVal="defaultOptions.NOT_tags" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" />
        <OptionsContacts v-model="options.contacts" :defaultVal="defaultOptions.contacts" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" />
        <OptionsOwner v-model="options.owner" :defaultVal="defaultOptions.owner" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" />
        <OptionsLastVisit v-model="options.last_visit" :defaultVal="defaultOptions.last_visit" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" />
        <OptionsCreated v-model="options.created" :defaultVal="defaultOptions.created" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" />
        <OptionsUpdated v-model="options.updated" :defaultVal="defaultOptions.updated" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" />
        <OptionsSort v-model="options.sort" :defaultVal="defaultOptions.sort" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" />
    </div>
</template>

<script>
    import { mapState, mapActions } from 'pinia';
    import { useCompaniesStore } from '@/stores/companies';
    import OptionsSort from '@/components/account/companies/prospects/OptionsSort';
    import OptionsLabel from '@/components/account/companies/prospects/OptionsLabel';
    import OptionsLists from '@/components/account/companies/prospects/OptionsLists';
    import OptionsTags from '@/components/account/companies/prospects/OptionsTags';
    import OptionsTagsExclude from '@/components/account/companies/prospects/OptionsTagsExclude';
    import OptionsOwner from '@/components/account/companies/prospects/OptionsOwner';
    import OptionsCreated from '@/components/account/companies/prospects/OptionsCreated';
    import OptionsUpdated from '@/components/account/companies/prospects/OptionsUpdated';
    import OptionsVisits from '@/components/account/companies/prospects/OptionsVisits';
    import OptionsContacts from '@/components/account/companies/prospects/OptionsContacts';
    import OptionsLastVisit from '@/components/account/companies/prospects/OptionsLastVisit';
    import OptionsPageSearch from '@/components/account/companies/prospects/OptionsPageSearch';
    import OptionsVisitDate from '@/components/account/companies/prospects/OptionsVisitDate';

    export default {
        name: 'ProspectsOptions',
        components: {
            OptionsSort,
            OptionsLabel,
            OptionsCreated,
            OptionsUpdated,
            OptionsVisits,
            OptionsContacts,
            OptionsLists,
            OptionsTags,
            OptionsTagsExclude,
            OptionsOwner,
            OptionsLastVisit,
            OptionsPageSearch,
            OptionsVisitDate
        },
        computed: {
            ...mapState(useCompaniesStore, ['audienceId', 'defaultProspectsOptions', 'hasDefaultProspectsOptions']),
            ...mapState(useCompaniesStore, {options: 'prospectsOptions', defaultOptions: 'defaultProspectsOptions'}),
        },
        methods: {
            ...mapActions(useCompaniesStore, ['updateOptions']),
            onChanged() {
                this.updateOptions(this.options, 'prospects');
            }
        }
    }
</script>